// extracted by mini-css-extract-plugin
export var banner = "_qk-0";
export var settingRow = "_qk-2";
export var titleIcon = "_qk-1";